import studentService from 'ApiService/Admin/studentService';
import Nodatafound from 'pages/Common/Nodatafound';
import { useEffect, useState, useCallback } from 'react';
import toast from 'react-hot-toast';

const History = ({ student, handleBackClick }) => {
  const [loading, setLoading] = useState(false);
  const [swapHistory, setSwapHistory] = useState([]);

  // =============================
  // Fetch Swap History (FIXED)
  // =============================
  const handleSwap = useCallback(async () => {
    if (!student?._id) return;

    setLoading(true);
    try {
      const payload = {
        studentId: student._id,
      };

      const response = await studentService.getStudentSwapHistory(payload);

      if (response.data.success) {
        setSwapHistory(response.data.data || []);
      } else {
        toast.error(response.data.message);
        setSwapHistory([]);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Error fetching swap history'
      );
      setSwapHistory([]);
    } finally {
      setLoading(false);
    }
  }, [student?._id]);

  // ✅ ESLINT SAFE
  useEffect(() => {
    handleSwap();
  }, [handleSwap]);

  return (
    <div className="w-full p-4">
      <div className="mb-6 text-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Swap History for {student?.name}
        </h4>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-10">
          <div className="border-t-transparent h-10 w-10 animate-spin rounded-full border-4 border-blue-500"></div>
        </div>
      ) : swapHistory.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="py-3 text-left text-gray-600">From</th>
                <th className="py-3 text-left text-gray-600">To</th>
                <th className="py-3 text-left text-gray-600">Swap Date</th>
                <th className="py-3 text-left text-gray-600">Reason</th>
                <th className="py-3 text-left text-gray-600">Notes</th>
              </tr>
            </thead>

            <tbody>
              {swapHistory.map((record) => (
                <tr key={record.swapId} className="border-b">
                  {/* FROM */}
                  <td className="py-3">
                    <div className="font-medium">
                      Course: {record.oldCourse?.name || '—'}
                    </div>
                    <div className="text-xs text-gray-500">
                      <span className="text-black font-bold">
                        BatchStructure –
                      </span>{' '}
                      {record.oldBatchStructure?.title || '—'} • Batch{' '}
                      {record.oldBatch?.batchNumber ?? '—'}
                    </div>
                  </td>

                  {/* TO */}
                  <td className="py-3">
                    <div className="font-medium">
                      Course: {record.newCourse?.name || '—'}
                    </div>
                    <div className="text-xs text-gray-500">
                      <span className="text-black font-bold">
                        BatchStructure –
                      </span>{' '}
                      {record.newBatchStructure?.title || '—'} • Batch{' '}
                      {record.newBatch?.batchNumber ?? '—'}
                    </div>
                  </td>

                  {/* DATE */}
                  <td className="py-3">
                    {record.swapDate
                      ? new Date(record.swapDate).toLocaleDateString()
                      : '—'}
                  </td>

                  {/* REASON */}
                  <td className="py-3">{record.reason || '—'}</td>

                  {/* NOTES */}
                  <td className="py-3">{record.notes || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="flex items-center justify-center dark:text-gray-600">
          <Nodatafound title="No swap history available for this student." />
        </div>
      )}

      <div className="mt-5 flex justify-end px-4">
        <button
          onClick={handleBackClick}
          className="linear rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition hover:bg-brand-800"
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default History;
